<template>
  <button class="btn-gift" :class="`btn-gift--${props.type}`"  :style="{ backgroundImage: `url('${BG}')` }">
    <div class="btn-gift__box">
      <GiftIcon class="btn-gift__icon" />
    </div>
    <slot />
  </button>
</template>

<script setup>
  import { Props } from './props.js';
  //----------------------
  import GiftIcon from '@shared/UI/SVG/GiftIcon.vue';
  //----------------------
  const props = defineProps(Props());
  //----------------------
  const BG = require('@/Shared/images/backgrounds/gift_bg.png');
</script>

<style scoped lang="scss">
  @import "./styles.scss";
</style>
